<template>
  <van-pull-refresh
    v-model="isLoading"
    @refresh="getTrendList"
    :pulling-text="$t('tips.pullrefresh')"
    :loosing-text="$t('tips.loosingrefresh')"
    :loading-text="$t('tips.loading')"
  >
    <div class="trend-list">
      <van-loading v-if="requestLoading && !trendList.length" class="page-loading" />
      <Trend v-for="item of trendList" :key="item.id" :data="item" />
      <button v-if="loadFailed" type="button" class="retry" @click="getTrendList">
        {{ $t('tips.loadfail') }}
      </button>
      <van-empty
        v-else-if="!requestLoading && !trendList.length"
        :description="$t('empty.noresult')"
      />
    </div>
  </van-pull-refresh>
  <router-link to="/m/home/trend/new" class="newmsg">
    <van-icon name="add" style="color: gold" />
  </router-link>
  <Menu />
</template>

<script>
import Trend from "../../../../components/mobile/Trend.vue";
import Menu from "../../../../components/mobile/Menu.vue";
export default {
  name: "MobileTrendList",
  inject: ["mobileTrendState"],
  data() {
    return {
      trendList: [],
      isLoading: false,
      requestLoading: false,
      loadFailed: false,
      requestId: 0,
    };
  },
  components: {
    Trend,
    Menu,
  },
  methods: {
    async getTrendList() {
      const requestId = ++this.requestId;
      this.requestLoading = true;
      this.loadFailed = false;
      try {
        const response = await this.axios.post_form("/member/trend/trend", {});
        if (requestId !== this.requestId) return;
        const res = response.data;
        const empty = res.status == 0 && res.msg === "暂无动态";
        if (res.status != 200 && !empty) throw new Error("Trend list rejected");
        this.trendList = empty ? [] : res.data;
      } catch (error) {
        if (requestId === this.requestId) this.loadFailed = true;
      } finally {
        if (requestId === this.requestId) {
          this.requestLoading = this.isLoading = false;
        }
      }
    },
  },
  created() {
    this.getTrendList();
  },
  activated() {
    if (this.mobileTrendState.needsRefresh) {
      this.mobileTrendState.needsRefresh = false;
      this.getTrendList();
    }
  },
  beforeUnmount() {
    this.requestId++;
  },
};
</script>

<style lang="scss" scoped>
.trend-list {
  min-height: calc(100vh - 60px);
}

.page-loading {
  padding: 20px;
  text-align: center;
}

.retry {
  display: block;
  width: 100%;
  padding: 20px;
  border: none;
  background: transparent;
  color: #969799;
  cursor: pointer;
}

.newmsg {
  position: fixed;
  right: 10px;
  bottom: 60px;
  font-size: 50px;
  color: gold;
  cursor: pointer;
}
</style>
